import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';
import { Dashboard } from '../services/dashboard';
import { HttpClientModule } from '@angular/common/http';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule, HttpClientModule, AdminHeader, AdminSidebar],
  templateUrl: './admin-dashboard.html',
  styleUrls: ['./admin-dashboard.css']
})
export class AdminDashboard implements OnInit, AfterViewInit {
  totalDrugs = 0;
  totalWards = 0;
  totalStores = 0;
  totalPatients = 0;
  totalInPatients = 0;
  totalOutPatients = 0;
  totalPatientsIssued = 0;
  totalIssues = 0;
  totalQuantityIssued = 0;
  totalStockItems = 0;
  expiringSoon = 0;
  lowStock = 0;

  recentActivities: string[] = [];
  chartInstance: any;

  constructor(private dashboardService: Dashboard) {}

  ngOnInit() {
    this.dashboardService.getDashboardSummary().subscribe((data) => {
      this.totalDrugs = data.totalDrugs;
      this.totalWards = data.totalWards;
      this.totalStores = data.totalStores;
      this.totalPatients = data.totalPatients;
      this.totalInPatients = data.totalInPatients;
      this.totalOutPatients = data.totalOutPatients;
      this.totalPatientsIssued = data.totalPatientsIssued;
      this.totalIssues = data.totalIssues;
      this.totalQuantityIssued = data.totalQuantityIssued;
      this.totalStockItems = data.totalStockItems;
      this.expiringSoon = data.expiringSoon;
      console.log(this.expiringSoon);
      this.lowStock = data.lowStock;
      console.log(this.lowStock);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.renderChart(), 100);
  }

  renderChart() {
    const ctx = document.getElementById('summaryChart') as HTMLCanvasElement;
    if (!ctx) return;

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    this.chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [
          'Stock Items', 'Drugs', 'Patients', 'In-Patients',
          'Out-Patients', 'Patients Issued', 'Quantity Issued',
          'Wards', 'Stores'
        ],
        datasets: [{
          label: 'Hospital Summary',
          data: [
            this.totalStockItems,
            this.totalDrugs,
            this.totalPatients,
            this.totalInPatients,
            this.totalOutPatients,
            this.totalPatientsIssued,
            this.totalQuantityIssued,
            this.totalWards,
            this.totalStores
          ],
          backgroundColor: [
            '#4caf50', '#2196f3', '#9c27b0', '#009688',
            '#ffc107', '#3f51b5', '#f44336', '#ff5722', '#795548'
          ]
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: { beginAtZero: true }
        }
      }
    });
  }
}
